import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorScreenHeader: {
		id: 'polaris-ideas.settings.fields.project-fields-screen.fields-list.error-screen-header',
		defaultMessage: "We couldn't load fields",
		description: 'Header of the error fields screen',
	},
});
